import { render, staticRenderFns } from "./StudentInvitations.vue?vue&type=template&id=0ba87949&scoped=true"
import script from "./StudentInvitations.vue?vue&type=script&lang=js"
export * from "./StudentInvitations.vue?vue&type=script&lang=js"
import style0 from "./StudentInvitations.vue?vue&type=style&index=0&id=0ba87949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba87949",
  null
  
)

export default component.exports